import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAppSelector } from "@/app/hooks";
import { selectIsAuthenticated, selectUser } from "@/features/auth/authSlice";
import { ROLE_ADMIN } from "@/types/auth";

interface AdminOnlyGuardProps {
  children: ReactNode;
  redirectTo?: string;
}

/**
 * Restricts access to Liberty Admin (ROLE_ADMIN) only.
 * Mirrors Angular admin_menus + ConfigComponent check for `/config`.
 */
export function AdminOnlyGuard({
  children,
  redirectTo = "/dashboard",
}: AdminOnlyGuardProps) {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const user = useAppSelector(selectUser);

  if (!isAuthenticated) {
    return <>{children}</>;
  }
  if (!user?.current_role) {
    return <>{children}</>;
  }

  if (user.current_role.role_name !== ROLE_ADMIN) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
